<template>
  <div class="h-outTabs">
    <ejs-tab ref="tabObj" id="tab_orientation" heightAdjustMode="Auto" :selecting="disableSelecting">
      <div class="e-tab-header">
        <div>{{headerText0}}</div>
        <div>{{headerText1}}</div>
        <div>{{headerText2}}</div>
      </div>
      <div class="e-content" style="padding: 10px;">
        <div id="idv1" style="display: none">
          <AddRoleP1 ref="editRoleP1" @childProps="editRoleProps1"></AddRoleP1>
        </div>
        <div id="idv2" style="display: none">
          <AddRoleP2 ref="editRoleP2" @childProps="editRoleProps2"></AddRoleP2>
        </div>
        <div id="idv3" style="display: none">
          <AddRoleP3 ref="editRoleP3" @childProps="editRoleProps3"></AddRoleP3>
        </div>
      </div>
    </ejs-tab>
  </div>
</template>

<script>
import AddRoleP1 from "./AddRoleP1";
import AddRoleP2 from "./AddRoleP2";
import AddRoleP3 from "./AddRoleP3";

export default {
  name: "EditRole",
  data() {
    return {
      headerText0: this.$t('Security.userInfo'),
      headerText1: this.$t('Security.authInfo'),
      headerText2: this.$t('SubscriberIms.organization'),
      roleProps1: {},
      roleProps2: {},
      roleProps3: {}
    };
  },
  methods: {
    editRoleProps1(data) {
      this.roleProps1 = data;
      this.setChildProps();
    },
    editRoleProps2(data) {
      this.roleProps2 = data;
      this.setChildProps();
    },
    editRoleProps3(data) {
      this.roleProps3 = data;
      this.setChildProps();
    },
    setChildProps() {
      this.$emit("childProps", {
        roleProps1: this.roleProps1,
        roleProps2: this.roleProps2,
        roleProps3: this.roleProps3
      });
    },
    init(roleParams) {
      let roleObj1 = this.$refs.editRoleP1;
      let roleObj2 = this.$refs.editRoleP2;
      let roleObj3 = this.$refs.editRoleP3;

      roleObj1.init(roleParams);
      roleObj1.queryRole();
      roleObj2.init(roleParams);
      roleObj2.initTreeData();
      roleObj3.init(roleParams);
      roleObj3.getNeList();
    },
    disableSelecting(e) {
      if (e.isSwiped) {
        e.cancel = true;
      }
    }
  },
  components: {
    AddRoleP1,
    AddRoleP2,
    AddRoleP3
  }
};
</script>
